<main>
  <loading-overlay [isLoading]="isLoading > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'BankReconciliation_Title' | translateWF: 'Bank Reconciliation' }}</h1>
      </div>
    </div>

    <p-panel class="mb-[1rem]">
      <p-card>
        <form [formGroup]="filterForm" class="grid-12 gap-[1rem] items-center">
          <div class="span-4">
            <p-floatlabel variant="on">
              <p-select id="accountId" [options]="bankAccounts()" formControlName="accountId" optionLabel="code" optionValue="id" appendTo="body" class="w-full" />
              <label for="accountId">{{ 'BankReconciliation_Account' | translateWF: 'Account' }}</label>
            </p-floatlabel>
          </div>
          <div class="span-4">
            <input type="file" accept=".txt,.sta,.mt940" (change)="onFileSelected($event)" />
          </div>
          <div class="span-4">
            <p-button [label]="'Match' | translateWF: 'Match'" (click)="onUpload()" [disabled]="!selectedFile || filterForm.invalid" />
          </div>
        </form>
      </p-card>
    </p-panel>

    <ng-container *ngIf="result() as r">
      <p-panel class="mb-[1rem]">
        <p-card>
          <div class="grid-4 gap-[1rem]">
            <div>
              <div class="text-sm">{{ 'BankReconciliation_AccountIdMatch' | translateWF: 'Account ID Matches' }}</div>
              <div class="text-lg">
                <p-tag [severity]="r.accountIdentifierMatches ? 'success' : 'warn'" [value]="r.accountIdentifierMatches ? 'YES' : 'CHECK'" />
              </div>
            </div>
            <div>
              <div class="text-sm">{{ 'BankReconciliation_OpeningBalance' | translateWF: 'Opening Balance' }}</div>
              <div class="text-lg">{{ r.mt940.openingBalance | number: '1.2-2' }}</div>
            </div>
            <div>
              <div class="text-sm">{{ 'BankReconciliation_ClosingBalance' | translateWF: 'Closing Balance' }}</div>
              <div class="text-lg">{{ r.mt940.closingBalance | number: '1.2-2' }}</div>
            </div>
            <div>
              <div class="text-sm">{{ 'BankReconciliation_Lines' | translateWF: 'MT940 Lines' }}</div>
              <div class="text-lg">{{ r.mt940.lines.length }}</div>
            </div>
          </div>
        </p-card>
      </p-panel>

      <div class="grid-12 gap-[1rem]">
        <div class="span-12">
          <p-panel>
            <ng-template pTemplate="header"
              ><strong>{{ 'BankReconciliation_Matched' | translateWF: 'Matched' }} ({{ r.matched.length }})</strong></ng-template
            >
            <p-card data-variant="compact">
              <p-table [value]="r.matched" styleClass="p-datatable-sm">
                <ng-template pTemplate="header">
                  <tr>
                    <th>BTX #</th>
                    <th>Posting Date</th>
                    <th>Direction</th>
                    <th>Amount</th>
                    <th>MT940 Ref</th>
                    <th>Match Kind</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-m>
                  <tr>
                    <td>{{ m.number }}</td>
                    <td>{{ m.postingDate | date: 'dd/MM/yyyy' }}</td>
                    <td>{{ m.direction }}</td>
                    <td>{{ m.amount | number: '1.2-2' }}</td>
                    <td>{{ m.mt940Line?.reference }}</td>
                    <td><p-tag severity="success" [value]="m.matchKind" /></td>
                  </tr>
                </ng-template>
              </p-table>
            </p-card>
          </p-panel>
        </div>

        <div class="span-12">
          <p-panel>
            <ng-template pTemplate="header">
              <strong>{{ 'BankReconciliation_Candidates' | translateWF: 'Candidates' }} ({{ r.candidates.length }})</strong>
            </ng-template>
            <ng-template pTemplate="icons">
              <p-button *ngIf="selectedCandidates.length > 0" [label]="'ConfirmSelected' | translateWF: 'Confirm Selected'" (click)="confirmSelected()" />
            </ng-template>
            <p-card data-variant="compact">
              <p-table [value]="r.candidates" [(selection)]="selectedCandidates" dataKey="bankTransactionId" styleClass="p-datatable-sm">
                <ng-template pTemplate="header">
                  <tr>
                    <th><p-tableHeaderCheckbox /></th>
                    <th>BTX #</th>
                    <th>Posting Date</th>
                    <th>Direction</th>
                    <th>Amount</th>
                    <th>MT940 Date</th>
                    <th>MT940 Ref</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-c>
                  <tr>
                    <td><p-tableCheckbox [value]="c" /></td>
                    <td>{{ c.number }}</td>
                    <td>{{ c.postingDate | date: 'dd/MM/yyyy' }}</td>
                    <td>{{ c.direction }}</td>
                    <td>{{ c.amount | number: '1.2-2' }}</td>
                    <td>{{ c.mt940Line?.valueDate | date: 'dd/MM/yyyy' }}</td>
                    <td>{{ c.mt940Line?.reference }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </p-card>
          </p-panel>
        </div>

        <div class="span-12-6">
          <p-panel>
            <ng-template pTemplate="header"
              ><strong>{{ 'BankReconciliation_UnmatchedMt940' | translateWF: 'Unmatched in MT940' }} ({{ r.unmatchedFromMt940.length }})</strong></ng-template
            >
            <p-card data-variant="compact">
              <p-table [value]="r.unmatchedFromMt940" styleClass="p-datatable-sm">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Date</th>
                    <th>Direction</th>
                    <th>Amount</th>
                    <th>Reference</th>
                    <th>Description</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-line>
                  <tr>
                    <td>{{ line.valueDate | date: 'dd/MM/yyyy' }}</td>
                    <td>{{ line.direction }}</td>
                    <td>{{ line.amount | number: '1.2-2' }}</td>
                    <td>{{ line.reference }}</td>
                    <td>{{ line.description }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </p-card>
          </p-panel>
        </div>

        <div class="span-12-6">
          <p-panel>
            <ng-template pTemplate="header"
              ><strong>{{ 'BankReconciliation_UnmatchedBank' | translateWF: 'Unmatched in Bank' }} ({{ r.unmatchedFromBank.length }})</strong></ng-template
            >
            <p-card data-variant="compact">
              <p-table [value]="r.unmatchedFromBank" styleClass="p-datatable-sm">
                <ng-template pTemplate="header">
                  <tr>
                    <th>BTX #</th>
                    <th>Posting Date</th>
                    <th>Direction</th>
                    <th>Amount</th>
                    <th>Banking Ref</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-m>
                  <tr>
                    <td>{{ m.number }}</td>
                    <td>{{ m.postingDate | date: 'dd/MM/yyyy' }}</td>
                    <td>{{ m.direction }}</td>
                    <td>{{ m.amount | number: '1.2-2' }}</td>
                    <td>{{ m.bankingReference }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </p-card>
          </p-panel>
        </div>
      </div>
    </ng-container>
  </div>
</main>
